(function () {
    function parseBool(v) {
      return String(v) === "true";
    }
  
    function initSwiperIn(root) {
      if (!root || !window.Swiper) return;
  
      const nodes = root.querySelectorAll("[data-tw-swiper]");
      nodes.forEach((el) => {
        if (el.__twSwiper) return;
  
        const autoplayEnabled = parseBool(el.dataset.autoplay);
        const autoplaySpeedSec = parseInt(el.dataset.autoplaySpeed || "5", 10);
        const effect = el.dataset.effect || "slide";
        const loop = el.dataset.loop ? parseBool(el.dataset.loop) : true;
        const speed = parseInt(el.dataset.speed || "600", 10);
  
        const wrap =
          el.closest("[data-tw-swiper-wrap]") ||
          el.parentElement ||
          el;
        const paginationEl =
          el.querySelector(".swiper-pagination") ||
          (wrap ? wrap.querySelector(".swiper-pagination") : null);
        const prevEl =
          el.querySelector(".swiper-button-prev") ||
          (wrap ? wrap.querySelector(".swiper-button-prev") : null);
        const nextEl =
          el.querySelector(".swiper-button-next") ||
          (wrap ? wrap.querySelector(".swiper-button-next") : null);
  
        el.__twSwiper = new window.Swiper(el, {
          loop,
          speed,
          effect,
          autoplay: autoplayEnabled
            ? { delay: autoplaySpeedSec * 1000, disableOnInteraction: false }
            : false,
          pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
          navigation:
            prevEl && nextEl ? { prevEl, nextEl } : undefined,
          // Accesibilidad básica
          a11y: { enabled: true },
          // Si usas fade, Swiper recomienda esto:
          fadeEffect: { crossFade: true }
        });
      });
    }
  
    function destroySwiperIn(root) {
      if (!root) return;
      root.querySelectorAll("[data-tw-swiper]").forEach((el) => {
        if (el.__twSwiper) {
          el.__twSwiper.destroy(true, true);
          el.__twSwiper = null;
        }
      });
    }
  
    // Init en carga normal
    document.addEventListener("DOMContentLoaded", () => initSwiperIn(document));
  
    // Shopify Theme Editor: cuando se recarga una sección
    document.addEventListener("shopify:section:load", (e) => {
      initSwiperIn(e.target);
    });
  
    document.addEventListener("shopify:section:unload", (e) => {
      destroySwiperIn(e.target);
    });
  })();
  